import builder from '../builders/base';

export default {
  signIn: credentials => builder()
    .setMethod('POST')
    .setUrl('auth/sign-in')
    .setData(credentials)
    .build(),
};



// WEBPACK FOOTER //
// ./src/services/modules/auth.js